import { Component, OnDestroy, OnInit } from "@angular/core";
import { Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { OPD_API_URL } from "../../../properties/opd-url-properties";
import { AppBaseService } from "projects/lib/medcare-core-lib/src/lib/services/http.service";
@Component({
  selector: "app-appointment-details",
  templateUrl: "./appointment-details.component.html",
  styleUrls: ["./appointment-details.component.scss"],
})
export class AppointmentDetailsComponent implements OnInit, OnDestroy {
  details: any = {};
  allPatient: any[] = [];
  radioSelected: any;
  private subscriptionList = new Subscription();
  constructor(
    public dialogRef: MatDialogRef<AppointmentDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private appBaseService: AppBaseService
  ) {
    console.log(data);
    this.details = data.details;
    this.radioSelected = data.allAppointment[0];
    this.allPatient = data.allAppointment;
  }

  /**
   *destro method
   *
   * @memberof AppointmentDetailsComponent
   */
  ngOnDestroy() {
    this.subscriptionList.unsubscribe();
  }

  /**
   *load method
   *
   * @memberof AppointmentDetailsComponent
   */
  ngOnInit() {}

  
  /**
   *on patient change
   *
   * @memberof AppointmentDetailsComponent
   */
  patientChange() {
    this.appBaseService.setResourceURL(OPD_API_URL.OPD_SERVICE);
    this.subscriptionList.add(
      this.appBaseService
        .getResource(
         OPD_API_URL.OPD_APPOINTMENT_PATIENt +
            this.radioSelected.apptNo
        )
        .subscribe((res) => {
          this.details = {
            name: res[0].subject.display,
            gender: res[0].temporaryPatient[0].gender.desc,
            doctor: res[0].entity.display,
            department: res[0].specialty[0].text,
            appointment: res[0].start,
            mrnNumber: res[0].temporaryPatient[0].TRN,
            mobile: res[0].temporaryPatient[0].mobileNo,
            photo: res[0].temporaryPatient[0].photo,
            id: res[0].temporaryPatient[0].idType.desc,
            idno: res[0].temporaryPatient[0].idNumber,
            email: res[0].temporaryPatient[0].email,
            company: res[0].company ? res[0].company.display : "",
            ref: res[0].referralEntityType
              ? res[0].referralEntityType.display
              : "",
            refType: res[0].referralEntityName
              ? res[0].referralEntityName.display
              : "",
            bookingType: res[0].bookingType ? res[0].bookingType.display : "",
            appno: res[0].identifier[0].value,
          };
        })
    );
  }
}
